import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHexoComponent } from './simple-icons-hexo.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHexoComponent ],
    exports:      [ SimpleIconsHexoComponent ],
    bootstrap:    []
})
export class SimpleIconsHexoModule {}
